import React, { useState, useEffect } from 'react';
import createPersistedState from './components/common/persistedState/PersistedState';

type CacheBusterProps = { children: React.ReactNode };

const CacheBuster = ({ children }: CacheBusterProps): JSX.Element => {
    const STORAGE_KEY = 'APP_VERSION';

    const [cacheStatus, setCacheStatus] = useState({
        loading: true,
        isLatestVersion: false
    });

    const useAppVersionState = createPersistedState(STORAGE_KEY);
    const [appVersion, setAppVersion] = useAppVersionState('');

    useEffect(() => {
        checkCacheStatus();
    }, []);

    const checkCacheStatus = async () => {
        const metaUrl = `/meta.json?${new Date().getTime()}`;

        try {
            const res = await fetch(metaUrl);
            const { version: serverVersion } = await res.json();

            const versionMatch = serverVersion === appVersion;

            if (!versionMatch) {
                // update the version in the meta.json file
                await setAppVersion(serverVersion);

                setCacheStatus({
                    loading: false,
                    isLatestVersion: false
                });
            } else {
                setCacheStatus({
                    loading: false,
                    isLatestVersion: true
                });
            }
        } catch (error) {
            console.error(error);
            setCacheStatus({
                loading: false,
                isLatestVersion: true
            });
        }
    };

    const refreshCacheAndReload = () => {
        if ('caches' in window) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then((names) => {
                names.map((name) => caches.delete(name));
            });
        }

        // clear browser cache and reload page
        window.location.reload();
    };

    if (cacheStatus.loading) return <></>;

    if (!cacheStatus.loading && !cacheStatus.isLatestVersion) {
        refreshCacheAndReload();
        return <></>;
    }

    return <>{children}</>;
};

export default CacheBuster;
